import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import { ContractorsRoute } from '../enums/contractors-route';
import { ContractorHelper } from '../helpers/contractor.helper';

export const contractorCardResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
) => {
  const contractorHelper = inject(ContractorHelper);
  const router = inject(Router);

  const uuid = route.paramMap.get('uuid')!;
  contractorHelper.openModal(uuid);

  const urlTree = router.parseUrl(ContractorsRoute.CONTRACTORS_LIST);
  return new RedirectCommand(urlTree, { replaceUrl: true });
};
